import React from 'react';
import WidgetEmbedPreviewFrame from '../../components/widget/WidgetEmbedPreviewFrame';
import { launcherVisualToWidgetSettings } from '../../components/widget/launcherVisualToWidgetSettings';
import type { WidgetLauncherVisual } from './widgetLauncherVisual';

interface FloatingPreviewProps {
  visual: WidgetLauncherVisual;
  open: boolean;
  onToggle: () => void;
  publishId: string | null;
  buttonVisible: boolean;
  onHideButton: () => void;
  apiToken?: string;
}

/** ホームのプレビューは、公開ウィジェットと同じ embed.js を透明な iframe で出す。 */
const FloatingPreview: React.FC<FloatingPreviewProps> = ({
  visual,
  publishId,
  buttonVisible,
  onHideButton,
  apiToken,
}) => {
  if (!publishId) return null;
  return (
    <WidgetEmbedPreviewFrame
      variant="overlay"
      publishId={publishId}
      apiToken={apiToken}
      settings={launcherVisualToWidgetSettings(visual)}
      buttonVisible={buttonVisible}
      onHideButton={onHideButton}
    />
  );
};

export default FloatingPreview;
